/* eslint-disable @typescript-eslint/no-explicit-any */


const tapEdge = async (cy: any, widgetEvents: any, runActions: any, actionsState: any) => {
  let singleTapTimer: any = null;
  let lastTapAt = 0;
  let lastTapTargetId: string | null = null;
  const DOUBLE_TAP_MS = 300;

  return await cy.on('tap', 'edge', async function (e) {
    const element = e.target;

    const now = performance.now();
    const targetId = typeof element.id === 'function' ? element.id() : element.id;
    const isDouble = lastTapTargetId === targetId && (now - lastTapAt) < DOUBLE_TAP_MS;
    lastTapAt = now;
    lastTapTargetId = targetId;

    if (isDouble) {
      if (singleTapTimer) {
        clearTimeout(singleTapTimer);
        singleTapTimer = null;
      }
      e.originalEvent?.preventDefault?.();
      e.stopPropagation?.();
      return;
    }

    if (singleTapTimer) clearTimeout(singleTapTimer);
    singleTapTimer = setTimeout(async () => {
      singleTapTimer = null;

      element.addClass('selected');
      cy.elements()
        .difference(element)
        .removeClass('selected');

      const id = parseInt(element.data().id);
      const key = widgetEvents?.find(event => event.type === 'onClick').key;

      if (!key) {
        alert('tapEdge: kein event gefunden');
        return null;
      }
      
      runActions(key, id, { ...actionsState, element: 'relation' }, null);
    }, DOUBLE_TAP_MS);
  });

};

export default tapEdge;
